import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" viewBox="0 0 20 20" {...props}><g transform="translate(3 3)" fill="#DADADA" stroke="#DADADA"><path id="$" d="M14 .81L13.19 0 7 6.19.81 0 0 .81 6.19 7 0 13.19l.81.81L7 7.81 13.19 14l.81-.81L7.81 7z" /></g></svg>);